export const USER_PROFILE = {
  UPDATE_MEMBER: 'UDPATE_MEMBER'

};
